import { render, staticRenderFns } from "./HistoryForm.vue?vue&type=template&id=ac72ccb8"
import script from "./HistoryForm.vue?vue&type=script&lang=js"
export * from "./HistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports